import {
	BackendService,
	MapService,
	SearchResult,
  StateService,
	UtilityService
}														from './';
import { Injectable }       from '@angular/core';
import { BehaviorSubject }  from 'rxjs';

export interface SearchInterface {
	getSearchResult(query: string, callback: any, context: any): void;
}

@Injectable()
export class SearchService {
	private searchResultsKey	= 'electra-search-results';

  currentResult:  	BehaviorSubject<SearchResult>;
  searchResultsBS:  BehaviorSubject<SearchResult[]>;

  focused = new BehaviorSubject(false);

	searchMarker: any = null;

	get searchResults(): SearchResult[] {
		var
		searchResults	= this.utilityService.getLocalStorageArray(this.searchResultsKey),
		retVal:				SearchResult[] = []

		if (Array.isArray(searchResults)) {
			for (var i = 0, len = searchResults.length; i < len; i++) {
				retVal.push(new SearchResult(searchResults[i]))
			}
		} else {
		  this.utilityService.setLocalStorageData(this.searchResultsKey, retVal);
		}

		return retVal
	}
	
	set searchResults(searchResults: SearchResult[]) {
		var temp: any[] = []

		for (var i = 0, len = searchResults.length; i < len; i++) {
			temp.push({
				address:	searchResults[i].address,
				lat:			searchResults[i].coord.lat,
				lng:			searchResults[i].coord.lng
			})
		}
		
		this.utilityService.setLocalStorageData(this.searchResultsKey, temp);

    if (typeof this.searchResultsBS !== 'undefined') {
		  this.searchResultsBS.next(searchResults);
    }
	}

	constructor(private backendService: BackendService, private mapService: MapService, private stateService: StateService, private utilityService: UtilityService) {
		this.currentResult 		= new BehaviorSubject(null);
    this.searchResultsBS  = new BehaviorSubject(this.searchResults);

		mapService.gmapsReady.push({ callback: () => {
			this.searchMarker =  new mapService.gmaps.Marker({
				icon:			{
					url: 'assets/electraAssets/searchResult.svg',
					scaledSize: new this.mapService.gmaps.Size(30, 42)
				},
				position: { lat: 0, lng: 0 },
				zIndex: 	50
			});

		  this.currentResult.subscribe(data => { this.gotCurrentResult(data); });
		}, context: this });

    console.log('Search service created');
	}

	gotCurrentResult(result: SearchResult) {
    if (result !== null) {
      this.searchMarker.setPosition(result.coord);
      this.searchMarker.setMap(this.mapService.map);
      this.mapService.setPosition(result.coord);

      if (!this.stateService.mobile && (this.stateService.app.value.about || this.stateService.app.value.terms)) {
        this.stateService.state = 'more';
      }
    } else {
      this.searchMarker.setMap(null);
    }
	}

  gotSearchResult(result?: SearchResult) {
		if (typeof result !== 'undefined') {
			this.updateHistory(result);

      this.currentResult.next(result);
		} else {
			console.error('No search results')
		}
	}

	resultClick(result: SearchResult) {
		console.log(result);
	}

	searchAddress(address: string) {
		this.backendService.getSearchResult(address, this.gotSearchResult, this);
	}
  
  updateHistory(sr: SearchResult) {
		let h = this.searchResultsBS.value;
		var found = -1;
		var hist: SearchResult[] = [];

		for (var i = 0, len = h.length; i < len; i++) {
			if (h[i].address === sr.address) {
				found = i;
			}
		}

		if (found > -1) {
			for (var i = 0, len = h.length; i < len; i++) {
				if (i !== found) {
					hist.push(h[i]);
				}
			}
		} else if (h.length === 5) {
			for (var i = 0, len = h.length; i < len; i++) {
				if (i !== 4) {
					hist.push(h[i]);
				}
			}
		} else {
			hist = h;
		}

		hist = ([sr]).concat(hist);

		this.searchResults = hist;
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/service/search.service.ts